(function () {
  var REBASE = 320;

  function create(root, opts) {
    var vp = opts.viewport;
    var track = opts.track;
    var speed = opts.speed > 0 ? opts.speed : 80;
    var delay = opts.delay > 0 ? opts.delay : 1500;
    var auto = opts.auto !== false;
    var onBuild = opts.onBuild || function () {};
    var onMove = opts.onMove || function () {};

    var raf = null;
    var timer = null;
    var settle = null;
    var resizeT = null;
    var fx = 0;
    var last = 0;
    var span = 0;
    var home = 0;
    var belt = 0;
    var paused = false;
    var visible = true;
    var ready = false;

    function originals() {
      return Array.prototype.filter.call(track.children, function (el) {
        return !el.hasAttribute('data-ps-clone');
      });
    }

    function copy(item) {
      var node = item.cloneNode(true);
      node.setAttribute('data-ps-clone', '');
      node.setAttribute('aria-hidden', 'true');
      var link = node.querySelector('a');
      if (link) link.tabIndex = -1;
      return node;
    }

    function padStart() {
      return parseFloat(window.getComputedStyle(track).paddingInlineStart) || 0;
    }

    function wrap(value) {
      if (!ready) return value;
      while (value >= home + belt) value -= belt;
      while (value < home) value += belt;
      return value;
    }

    function flatten() {
      if (!fx) return;
      var next = vp.scrollLeft + fx;
      fx = 0;
      track.style.transform = 'translate3d(0,0,0)';
      vp.scrollLeft = next;
    }

    function align(el) {
      if (!el) return;
      flatten();
      var delta = el.getBoundingClientRect().left - vp.getBoundingClientRect().left - padStart();
      vp.scrollLeft = wrap(vp.scrollLeft + delta);
    }

    function build() {
      var nodes = track.querySelectorAll('[data-ps-clone]');
      for (var n = 0; n < nodes.length; n++) nodes[n].parentNode.removeChild(nodes[n]);
      track.style.transform = 'translate3d(0,0,0)';
      fx = 0;
      ready = false;
      belt = 0;
      home = 0;
      span = 0;

      var items = originals();
      if (!items.length) {
        onBuild();
        return;
      }

      if (auto && items.length > 2) {
        var reach = vp.clientWidth + 240;
        var need = 1;
        while (need < items.length && items[need].offsetLeft - items[0].offsetLeft < reach) need++;
        if (need > items.length) need = items.length;

        var head = document.createDocumentFragment();
        for (var i = items.length - need; i < items.length; i++) head.appendChild(copy(items[i]));
        track.insertBefore(head, items[0]);

        var tail = document.createDocumentFragment();
        var mark = null;
        for (var j = 0; j < need; j++) {
          var node = copy(items[j]);
          if (!mark) mark = node;
          tail.appendChild(node);
        }
        track.appendChild(tail);

        belt = mark.offsetLeft - items[0].offsetLeft;
      }

      align(items[0]);
      home = vp.scrollLeft;
      span = items[items.length - 1].offsetLeft - items[0].offsetLeft;
      ready = belt > 0;
      onBuild();
    }

    function tick(stamp) {
      raf = window.requestAnimationFrame(tick);
      if (!last) {
        last = stamp;
        return;
      }
      var dt = stamp - last;
      last = stamp;
      if (paused || !visible || document.hidden) return;
      if (dt > 100) dt = 100;
      fx += (speed * dt) / 1000;
      if (fx >= REBASE) {
        vp.scrollLeft = wrap(vp.scrollLeft + fx);
        fx = 0;
      }
      track.style.transform = 'translate3d(' + -fx + 'px,0,0)';
      onMove();
    }

    function run() {
      if (raf || !auto || !ready) return;
      last = 0;
      raf = window.requestAnimationFrame(tick);
    }

    function halt() {
      if (!raf) return;
      window.cancelAnimationFrame(raf);
      raf = null;
    }

    function pause() {
      window.clearTimeout(timer);
      if (paused) return;
      flatten();
      paused = true;
      last = 0;
      root.classList.remove('is-auto');
    }

    function resume() {
      if (!auto || !ready) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        vp.scrollLeft = wrap(vp.scrollLeft);
        fx = 0;
        paused = false;
        last = 0;
        root.classList.add('is-auto');
      }, delay);
    }

    function nudge(distance) {
      pause();
      vp.scrollBy({ left: distance, behavior: 'smooth' });
      resume();
    }

    function onScroll() {
      onMove();
      if (!paused) return;
      resume();
      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        if (paused) vp.scrollLeft = wrap(vp.scrollLeft);
      }, 160);
    }

    vp.addEventListener('pointerdown', pause);
    vp.addEventListener('pointerup', resume);
    vp.addEventListener('pointercancel', resume);
    vp.addEventListener('touchstart', pause, { passive: true });
    vp.addEventListener('touchend', resume, { passive: true });
    vp.addEventListener('touchcancel', resume, { passive: true });
    vp.addEventListener('wheel', function () { pause(); resume(); }, { passive: true });
    vp.addEventListener('mouseenter', pause);
    vp.addEventListener('mouseleave', resume);
    vp.addEventListener('focusin', pause);
    vp.addEventListener('focusout', resume);
    vp.addEventListener('scroll', onScroll, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) { run(); } else { halt(); }
      }, { threshold: 0 });
      io.observe(root);
    }

    document.addEventListener('visibilitychange', function () { last = 0; });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(function () {
        halt();
        build();
        if (!paused) run();
      }, 200);
    }, { passive: true });

    return {
      start: function () {
        build();
        if (auto) root.classList.add('is-auto');
        run();
      },
      align: align,
      nudge: nudge,
      pause: pause,
      resume: resume,
      position: function () { return wrap(vp.scrollLeft + fx); },
      home: function () { return home; },
      span: function () { return span; }
    };
  }

  window.UrbPsBelt = { create: create };
})();
